import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { formatPhoneNumber } from "@shared/utils/text/utils";

export default function MapTooltipPurchaserDetails({
  email,
  nameOnTicket,
  phoneNumber = null,
  headerLabel,
  statusLabel,
}: {
  email: string;
  nameOnTicket: string;
  phoneNumber?: string | null;
  headerLabel: string;
  statusLabel: string;
}): JSX.Element {
  const { t } = useTranslation("seating");
  return (
    <Flex
      justifyContent="space-between"
      mb="2xs"
      minW="200px"
      direction="column"
      borderTop="1px solid"
      borderColor="gray.700"
    >
      <Flex direction="column">
        <Text fontSize="sm" color="gray.500">
          {headerLabel || t("Not provided")}
        </Text>
        <Text color="light.500" letterSpacing="-0.5px" fontWeight="bold">
          {nameOnTicket || t("Not provided")}
        </Text>
      </Flex>
      <Flex direction="column">
        <Text fontSize="sm" color="gray.500">
          {t("Email")}
        </Text>
        <Text color="light.500" letterSpacing="-0.5px" fontWeight="bold">
          {email || t("Not provided")}
        </Text>
      </Flex>

      <Flex direction="column">
        <Text fontSize="sm" color="gray.500">
          {t("Phone")}
        </Text>
        <Text color="light.500" letterSpacing="-0.5px" fontWeight="bold">
          {formatPhoneNumber(phoneNumber) || t("Not provided")}
        </Text>
      </Flex>

      <Flex direction="column">
        <Text fontSize="sm" color="gray.500">
          {t("Status")}
        </Text>
        <Text color="light.500" letterSpacing="-0.5px" fontWeight="bold">
          {statusLabel}
        </Text>
      </Flex>
    </Flex>
  );
}
